module.exports = __webpack_public_path__ + "img/icon-school6.6a282628.png";